import { render, staticRenderFns } from "./ChangePswPage.vue?vue&type=template&id=2850bcd3&scoped=true&"
import script from "./ChangePswPage.vue?vue&type=script&lang=js&"
export * from "./ChangePswPage.vue?vue&type=script&lang=js&"
import style0 from "./ChangePswPage.vue?vue&type=style&index=0&id=2850bcd3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2850bcd3",
  null
  
)

export default component.exports